export default {
  promotion: {},
  promotionHelpers: {}
}



// WEBPACK FOOTER //
// ./src/components/promotion/store/state.js